$(document).ready(function(){

  // Hero Slider
  $('.hero-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    speed: 800,
    dots: true,
    arrows: false,
    pauseOnHover: false
  });

  // Garmin Carousel
  $('.garmin-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    dots: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  });

});
